import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import Column from 'components/ui/show/Column';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import InnerColumn from 'components/ui/show/InnerColumn';
import Table from 'components/ui/table/Table';
import TableRow from 'components/ui/table/TableRow';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { TableRowColumn } from 'material-ui/Table';
import { CheckIcon, DeactivateIcon } from 'assets/materialIcons/materialIcons';

const InvitationRequestsList = (props) => {
    const {
        invitationsStatus,
        invitations,
        onAcceptInvitation,
        onDenyInvitation,
        translate,
    } = props;

    const wasInvitationReplied = (id) => {
        return invitationsStatus.some((invitation) => {
            return invitation.id === id;
        });
    };

    const getInvitationLabel = (id) => {
        return invitationsStatus.filter((invitation) => {
            return invitation.id === id;
        })[0].label;
    };

    return (
        <Column title={ translate('resources.invitations.request_title') }>
            <InnerColumn>
                {
                    invitations && !invitations.length ?
                        translate('resources.invitations.no_invitations')
                        :
                        <Table>
                            <TableRow>
                                <HeaderColumn style={ { width: '100%' } }>
                                    Email
                                </HeaderColumn>
                            </TableRow>
                            {
                                invitations && invitations.map((invitation) => {
                                    return (
                                        <TableRow key={ invitation.email }>
                                            <TableRowColumn>
                                                {invitation.email}
                                            </TableRowColumn>
                                            <TableRowColumn>
                                                {
                                                    invitationsStatus && wasInvitationReplied(invitation.id) ?
                                                        translate(getInvitationLabel(invitation.id)) :
                                                        <div>
                                                            <Button
                                                                icon={ <CheckIcon color={ theme.palette.mossGreen }/> }
                                                                title={ translate('resources.invitations.actions.accept.title') }
                                                                onClick={ () => {
                                                                    return onAcceptInvitation(invitation.id);
                                                                } }
                                                                primary={ false }
                                                            />
                                                            <Button
                                                                icon={ <DeactivateIcon color={ theme.palette.redOrange } style={ { transform: 'rotate(45deg)' } } /> }
                                                                title={ translate('resources.invitations.actions.deny.title') }
                                                                onClick={ () => {
                                                                    return onDenyInvitation(invitation.id);
                                                                } }
                                                                primary={ false }
                                                            />
                                                        </div>
                                                }

                                            </TableRowColumn>
                                        </TableRow>
                                    );
                                })
                            }
                        </Table>
                }
            </InnerColumn>
        </Column>
    );
};

InvitationRequestsList.propTypes = {
    invitationsStatus: PropTypes.array,
    invitations: PropTypes.array,
    onAcceptInvitation: PropTypes.func.isRequired,
    onDenyInvitation: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(InvitationRequestsList);



// WEBPACK FOOTER //
// ./src/pages/invitations/requests/InvitationRequestsList.js